import { Observable } from 'rxjs';

export abstract class QueryVisitor {
    public abstract visit<T>(queryObject: T): Observable<T>;
}

